import { Users, Clock, Baby, Utensils, CalendarDays, Repeat } from "lucide-react";
import { ImageCarousel } from "../deck/ImageCarousel";
import { Card, Eyebrow, Note, Reveal, Section, SectionHeader, StatusBadge } from "../deck/primitives";

const PROGRAM = [
  "Market-hall-style perimeter building", "Small restaurant suites", "Local food operators", "Boutique / vendor spaces",
  "Arcade / entertainment", "Large central courtyard", "Family play areas", "Splash / water feature", "Lawn",
  "Event stage", "Shaded seating", "Community gathering areas", "Seasonal programming",
];

const IMAGES = [
  { src: "/img/rendering.jpg", alt: "Courtyard market hall — aerial view" },
  { src: "/concept/concept-1.jpg", alt: "Evening events lawn + amphitheater stage" },
  { src: "/concept/concept-2.jpg", alt: "Dining promenade + water feature" },
  { src: "/concept/concept-3.jpg", alt: "Restaurant + rooftop terrace building" },
  { src: "/concept/concept-4.jpg", alt: "Family play courtyard + arcade frontage" },
];

const OUTCOMES = [
  { i: Users, t: "Downtown visitation" }, { i: Clock, t: "Dwell time" }, { i: Baby, t: "Family activity" },
  { i: Utensils, t: "Restaurant traffic" }, { i: CalendarDays, t: "Community events" }, { i: Repeat, t: "Repeat visitation" },
];

export default function Concept() {
  return (
    <Section testid="section-concept">
      <SectionHeader num="04" eyebrow="Development Concept" title="Current Murrieta Family Commons Design" lede="An enclosed courtyard market-hall destination — a perimeter of small-format food, vendor and entertainment suites wrapped around a large, shaded family courtyard." status="preliminary" />
      <div className="grid xl:grid-cols-12 gap-6">
        <Reveal className="xl:col-span-8">
          <Card className="overflow-hidden">
            <ImageCarousel images={IMAGES} />
          </Card>
        </Reveal>
        <Reveal delay={0.1} className="xl:col-span-4">
          <Card className="p-7 h-full">
            <div className="flex items-center justify-between"><Eyebrow>Program</Eyebrow><span className="text-xs text-steel">~40,000 rentable SF</span></div>
            <ul className="mt-5 space-y-0">
              {PROGRAM.map((t, i) => (
                <li key={t} className="flex items-center gap-4 py-2.5 border-b border-line/70 last:border-0 text-[14px] text-char">
                  <span className="font-mono text-[10px] text-arq w-5">{String(i + 1).padStart(2, "0")}</span>{t}
                </li>
              ))}
            </ul>
          </Card>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="mt-12">
        <Eyebrow>A destination designed to increase</Eyebrow>
        <div className="mt-5 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
          {OUTCOMES.map(({ i: I, t }) => (
            <Card key={t} className="p-6 metric-card" data-testid={`concept-outcome-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <I size={20} className="text-arq" />
              <div className="mt-5 text-ink text-[15px]">{t}</div>
            </Card>
          ))}
        </div>
      </Reveal>
      <Note className="mt-6">
        <span className="mr-3"><StatusBadge s="tbv" /></span>Rendering is conceptual and not an approved site plan. Final area plan, parking, access and utilities remain to be engineered.
      </Note>
    </Section>
  );
}
